var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16667 15.6666C2.16667 16.1087 2.34226 16.5326 2.65482 16.8451C2.96738 17.1577 3.39131 17.3333 3.83333 17.3333H12.1667C12.6087 17.3333 13.0326 17.1577 13.3452 16.8451C13.6577 16.5326 13.8333 16.1087 13.8333 15.6666V5.66663H15.5V3.99996H12.1667V2.33329C12.1667 1.89127 11.9911 1.46734 11.6785 1.15478C11.3659 0.842221 10.942 0.666626 10.5 0.666626H5.5C5.05797 0.666626 4.63405 0.842221 4.32149 1.15478C4.00893 1.46734 3.83333 1.89127 3.83333 2.33329V3.99996H0.5V5.66663H2.16667V15.6666ZM5.5 2.33329H10.5V3.99996H5.5V2.33329ZM12.1667 5.66663V15.6666H3.83333V5.66663H12.1667Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7.33329H7.16667V14H5.5V7.33329ZM8.83333 7.33329H10.5V14H8.83333V7.33329Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.c80f1723ef33ad880ee118c138ca2e40.svg";
export { ForwardRef as ReactComponent };